export default class RoleGroupsService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getListOptions() {
		return this.apiService.callGet('roleGroups/getListOptions');
	}

	createEntity(params){
		return this.apiService.callPost('roleGroups', params);
	}

	getEntity(id, params) {
		return this.apiService.callGet('roleGroups/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('roleGroups', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('roleGroups/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('roleGroups/' + id, params)
	}

	getSimpleList() {
		return this.apiService.callGet('roleGroups/simple_list')
	}

	getEditAllowedSectionList() {
		return this.apiService.callGet('roleGroups/editAllowedSectionList')
	}
}



// WEBPACK FOOTER //
// ./src/service/RoleGroupsService.js